<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="单号:" prop="distributionNo">
              <el-input  placeholder="" v-model="searchFrom.distributionNo"></el-input>
            </el-form-item>
              <el-form-item label="状态:" prop="status">
                <el-select  v-model="searchFrom.status"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待配货" value="1"></el-option>
                  <el-option label="配货中" value="2"></el-option>
                  <el-option label="已完成" value="3"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="创建人:" prop="createUserName">
              <el-input  placeholder="" v-model="searchFrom.createUserName"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item   v-if="btnFlg[1]" >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[2]" >
            <el-button type="primary" @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  v-if="btnFlg[3]"   @click="mingXiFn(scope.row)">明细</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="distributionNo" min-width="200"  :formatter="emptyFn" label="单号"></el-table-column>
         <el-table-column property="status" width="120" label="状态" >
          <template scope="scope">
            {{[ "待配货", "配货中","已完成" ][scope.row.status-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="weight" width="120" :formatter="emptyFn" label="重量(吨)"></el-table-column>
        <el-table-column prop="number" width="120" :formatter="emptyFn" label="件数(件)"></el-table-column>
        <el-table-column prop="shipName"  min-width="200" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="referenceCapacity" width="120" :formatter="emptyFn" label="船舶载重(吨)"></el-table-column>
        <el-table-column prop="createUserName" width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
                <el-form-item label="船舶名称:" prop="shipNameO">
                <el-select  v-model="addFrom.shipNameO"  value-key="id"  placeholder="请选择" filterable  @change="shipNameChange">
                  <el-option v-for="(item,index) in CBList" :label="item.shipName" :value="item" :key="index"></el-option>
                 </el-select>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { cShipInfoList, SDBlist, SDBadd, SDBdelete } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新建',
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        shipNameO: [
          { required: true, message: '请选择船舶名称', trigger: 'blur' }
        ]
      },
      addFrom: {},
      CBList: [], // 船舶列表
      btnFlg: [],
      btnIdArr: ['00KP004B001', '00KP004B002', '00KP004B003', '00KP004B004']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shipingPeiHuo')
    cShipInfoList().then(res => {
      this.CBList = res
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 明细
    mingXiFn (row) {
      this.$router.push({ path: '/shipingPeiHuo/mingXi', query: { id: row.id } })
    },
    // 选择船名
    shipNameChange () {
      this.$set(this.addFrom, 'shipId', this.addFrom.shipNameO.id)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      SDBlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
    },
    saveFn (formName) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      SDBadd(this.addFrom).then(res => {
        loading.close()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].status == 1) {
          this.$confirm('是否执行删除操作?', '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            SDBdelete({ id: selectData[0].id }).then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        } else {
          this.$alert('该数据不能进行删除操作', '系统提示')
        }
      }
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
